
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {RegisterClientInput, RegisterClientOutput, UnRegisterClientInput, UnRegisterClientOutput } from '../../types/notification';

export default  {
 
    
    register(data : RegisterClientInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RegisterClientOutput, RegisterClientInput >("POST",`${config.apiUrl.notification}/ClientsCommand/Register`,data, options);
    },
 
    
    unRegister(data : UnRegisterClientInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UnRegisterClientOutput, UnRegisterClientInput >("POST",`${config.apiUrl.notification}/ClientsCommand/UnRegister`,data, options);
    },
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.notification}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.notification}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },
 
    
    appointment(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.notification}/NotificationHandler/Appointment`,data, options);
    },

};